import { Component, OnInit, ViewChild } from "@angular/core";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { TypeDocumentGarantie } from "src/app/parametrage/core/model/garanties/type-document-garantie";
import { NatureGarantieDocument } from "src/app/parametrage/core/model/garanties/NatureGarantieDocument";
import { TypeDocumentChampGarantieService } from "src/app/parametrage/core/service/type-document-champ-garantie.service";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { NgbdModalConfirm } from "src/app/core/services/utils/modal-confirm";

@Component({
  selector: "app-set-type-document-nature-garantie",
  templateUrl: "./set-type-document-nature-garantie.component.html",
  styleUrls: ["./set-type-document-nature-garantie.component.scss"],
})
export class SetTypeDocumentNatureGarantieComponent implements OnInit {
  natureGarantieId: number;
  natureGarantie: NatureGarantie;
  natureGarantieDocuments: NatureGarantieDocument[];
  documents: TypeDocumentGarantie[];
  selectedDocumentId: number;
  isObligatoire: boolean = false;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _natureGarantieService: NatureGarantieService,
    private _typeDocumentGarantieService: TypeDocumentChampGarantieService) {}

  ngOnInit() {
    this.getAllDocuments();
    this.getNatureGarantieDocuments();
  }

  getNatureGarantieDocuments() {
    this._natureGarantieService
      .getNatureGarantieDocuments(this.natureGarantieId)
      .subscribe((data) => {
        this.natureGarantieDocuments = data;
      });
  }

  getAllDocuments() {
    this._typeDocumentGarantieService
      .getTypeDocumentGaranties()
      .subscribe((data) => {
        this.documents = data;
      });
  }

  addNatureGarantieDocument() {
    var input = new NatureGarantieDocument();
    input.typeDocumentGarantieId = this.selectedDocumentId;
    input.obligatoire = this.isObligatoire;
    this._natureGarantieService
      .addNatureGarantieDocument(input, this.natureGarantieId)
      .subscribe((data) => {
        this.selectedDocumentId = null;
        this.isObligatoire = false;
        this.getNatureGarantieDocuments();
      });
  }

  deleteDocument(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelle;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer ce type de document";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        this._natureGarantieService
          .deleteNatureGarantieDocument(row.id)
      .subscribe((data) => {
            this.getNatureGarantieDocuments();
          });
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }
}
